import React from 'react';
import { TOTAL_PACKAGES, PACKAGE_PRICES } from '../../config/contracts';

// Native <select> dropdown — clean, accessible, and mobile-native.
const PackageSelector = ({ selected, onChange, maxPackage }) => {
  const options = [];
  for (let i = 1; i <= TOTAL_PACKAGES; i++) {
    const locked = maxPackage !== undefined && i > maxPackage;
    options.push({ id: i, price: PACKAGE_PRICES[i - 1], locked });
  }

  return (
    <div className="pkg-dropdown-wrap">
      <select
        className="pkg-dropdown"
        value={selected}
        onChange={(e) => onChange(parseInt(e.target.value, 10))}
      >
        {options.map((o) => (
          <option key={o.id} value={o.id} disabled={o.locked}>
            {o.locked ? '🔒 ' : ''}Package {o.id} — ${o.price} USDT{o.locked ? ' (locked)' : ''}
          </option>
        ))}
      </select>
      <div className="pkg-dropdown-arrow">▾</div>
    </div>
  );
};

export default PackageSelector;
